import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'aff-signout-redirect',
  templateUrl: './signout-redirect.component.html',
  styleUrls: ['./signout-redirect.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SignoutRedirectComponent {
  constructor(private router: Router) {}

  navigateToHomepage(): void {
    this.router.navigateByUrl('/');
  }
}
